import { Duration, DurationObjectUnits } from 'luxon';

export function convertToHumanReadable(
  scaledValue: { [key: string]: number },
  maxUnits: number,
): string {

  const duration =
    Duration
      .fromObject(scaledValue)
      .shiftTo('days', 'hours', 'minutes', 'seconds', 'milliseconds');

  const nonZeroUnits: DurationObjectUnits = {};

  let i = 0;

  for (const key of Object.keys(duration.toObject()) as (keyof DurationObjectUnits)[]) {
    if (duration.get(key) !== 0) {
      nonZeroUnits[key] = duration.get(key);

      if (++i == maxUnits) {
        break;
      }
    }
  }

  return Duration
    .fromObject(nonZeroUnits)
    .toHuman() || '';
}
